<template>
    <div class="logwork-comp">
        <div v-if="!customTimeUI" class="quick-time-btns">
            <VButton
                @clickHandler="showModal('minute', '15')"
            >15m</VButton>
            <VButton
                @clickHandler="showModal('minute', '30')"
            >30m</VButton>
            <VButton
                @clickHandler="showModal('minute', '45')"
            >45m</VButton>
            <VButton
                @clickHandler="showModal('hour', '1')"
            >1h</VButton>
        </div>
        <VButton 
            v-if="!customTimeUI"
            @clickHandler="customTime"
            fullWidth
            class="mb-10"
        >Custom</VButton>
        <!-- <VButton 
            @clickHandler="showTrackedTimeModal"
            fullWidth
            theme="secondary"
        >Time Tracked</VButton> -->
        <div v-if="customTimeUI" class="custom-time">
            <div class="time-container">
                <div class="time-element pr-1">
                    <Textfield
                        v-model="form.hour"
                        :required="true"
                        class="time-input"
                        placeholder="Hours"
                        @keydownenter="logTime"
                        ref="hourInput"
                    />
                </div>
                <div class="time-element pl-1">
                    <Textfield
                        v-model="form.minute"
                        :required="true"
                        class="time-input"
                        placeholder="Minutes"
                        @keydownenter="logTime"
                    />
                </div>
            </div>
            <div v-if="customTimeUI" class="note-block">
                <Textfield 
                    v-model="form.note"
                    :placeholder="'Note'"
                    @keydownenter="logTime"
                    ref="noteTextarea"
                />
                <Textfield v-model="form.date" type="date" />
            </div>
            <div class="flex-gap-9">
                <VButton
                    v-if="customTimeUI"
                    @clickHandler="logTime"
                    :disabled="((form.hour.trim().length <= 0 && form.minute.trim().length <= 0) || (form.hour == '0' && form.minute == '0')) || clickedLogBtn"
                    fullWidth
                    active
                >Log</VButton>
                <VButton
                    v-if="customTimeUI"
                    @clickHandler="resetFields"
                    fullWidth
                >Cancel</VButton>
            </div>
        </div>
        <Flash ref="show" />

        <VModal title="Time Tracked" ref="tracked-time-modal" class="time-tracked-modal" size="md" :flexheight="true">
            <TimeTrackerModal
                :timeRegisteredToday="timeRegisteredToday"
                :tags="tags"
            />
        </VModal>
    </div>
</template>

<script>
import { api } from "@/mixins/axios";
import Select from "@/components/atoms/Select.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import VButton from "@/components/atoms/VButton.vue";
import VModal from "@/components/atoms/VModal.vue";
import Flash from "@/components/Flash.vue";
import TimeTrackerModal from "@/components/molecules/TimeTrackerModal.vue";

export default {
    name: "LogWork",
    components: { Textfield, Select, VButton, Flash, VModal, TimeTrackerModal },
    props: ["task", 'tags'],
    data: function () {
        return {
            form: {
                date: new Date().toISOString().split("T")[0],
                note: "",
                hour: '',
                minute: '',
            },
            hours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            minutes: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
            customTimeUI: false,
            clickedLogBtn: false,
            timeRegisteredToday: []
        };
    },
    computed: {
        userID() {
            return this.$store.getters.userID
        }
    },
    methods: {
        logHour(hour) {
            this.form.hour = hour;
        },
        logMinute(minute) {
            this.form.minute = minute;
        },
        showModal(type, value) {
            this.form.hour = '0'
            this.form.minute = '0'
            this.form.date = new Date().toISOString().split("T")[0]
            this.customTimeUI = true
            if(type && value) {
                this.form[type] = value;
            } else {
                this.form.hour = '0';
                this.form.minute = '0';
            }
            this.$nextTick(() => this.$refs.noteTextarea.$el.querySelector('input.textfield').focus())
        },
        customTime() {
            this.customTimeUI = true;
            this.$nextTick(() => this.$refs.hourInput.$el.querySelector('input.textfield').focus());
        },
        minutesToHours(min) {
            var hours = (min / 60);
            var rhours = Math.floor(hours);
            var minutes = (hours - rhours) * 60;
            var rminutes = Math.round(minutes);
            return rhours + "h " + rminutes + "m";
        },
        async logTime() {
            // TODO implement with real data
            if (this.form.hour == '0' && this.form.minute == '0') return
            else {
                try {
                    let minutes = Number(this.form.hour) * 60 + Number(this.form.minute)
                    let data = {
                        id: this.task.id,
                        body:  this.form.note,
                        created_at: this.form.date,
                        minutes: minutes,
                    };
                    this.clickedLogBtn = true

                    const response = await api.post(`/task_logwork`, data);

                    if (response.data.msg === 'ok') {
                        this.$refs.show.showLogworkFlash(`Registered ${this.minutesToHours(minutes)} on task ${this.task.title}`, 7000);
                        this.timeRegisteredToday = Object.keys(response.data.time).map(key => ({
                            id: key,
                            ...response.data.time[key]
                        }));
                        this.resetFields()
                        this.$store.dispatch('editTaskEvents', response.data.data)
                        this.$emit('updateTaskEvents')
                    }
                } catch (err) {
                    console.log(err)
                    this.$refs.show.showFlashError(err?.response?.data?.msg || err?.message || 'Time Registration Failed. Try again!');
                    this.resetFields()
                }
            }
        },
        resetFields() {
            this.clickedLogBtn = false
            this.form.note = "";
            this.form.hour = '';
            this.form.minute = '';
            this.form.date = new Date().toISOString().split("T")[0]
            this.customTimeUI = false
        },
        formatTitleLength(title) {
            if (title.length > 6) {
                return `${title.substring(0, 6).trim()}...`
            } else {
                return title
            }
        },
        convertTimeToHMSystem(min, unit) {
            const decimalHours = min / 60;
            const hours = Math.floor(decimalHours);
            const minutes = min % 60;

            if (unit === 'm') {
                return minutes;
            } else if (unit === 'h') {
                return hours;
            } else {
                return `${hours}h ${minutes}m`;
            }
        },
        totalHoursToday() {
            let total = 0
            this.timeRegisteredToday.forEach(time => total += time.minutes)
            return this.convertTimeToHMSystem(total)
        },
        showTrackedTimeModal() {
            this.$refs['tracked-time-modal'].showModal()
        },
    },
};
</script>

<style scoped lang="scss">
.title-wrap {
    i {
        font-size: 28px;
    }
}
.time-container {
    display: flex;
    flex-direction: row;
    margin-top: 13px;
    gap: 5px;

    .textfield {
        margin-bottom: 0;
    }

    .time-element {
        width: 50%;
        margin: 0;

        .time-input, .note-block {
            .textfield {
                background-color: var(--primary-bg);
                border: 0.5px solid var(--outline);
                border-radius: 10px;
            }
        }
    }
}

.quick-time-btns {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 10px;

    .btn {
        height: 35px;
        width: 70px;
    }
}

.btn.w-100 {
    height: 35px;
}

.note-block {
    margin-bottom: 13px;
}

.time-table {
    outline: 1px solid #3E3E3E;
    width: 100%;
    border-radius: 6px;
    margin-top: 10px;

    thead { border-bottom: 1px solid #3E3E3E; }

    .total-tr { border-top: 1px solid #3E3E3E; }

    th, td { padding: 6px; }
}

.logwork-comp {
    margin-bottom: 10px;
}

.mb-10 {
    margin-bottom: 10px;
}
</style>
